import createReactComponent from '../createReactComponent';
export default createReactComponent('angle', 'IconAngle', [
  ['path', { d: 'M21 19h-18l9 -15', key: 'svg-0' }],
  ['path', { d: 'M20.615 15.171h.015', key: 'svg-1' }],
  ['path', { d: 'M19.515 11.771h.015', key: 'svg-2' }],
  ['path', { d: 'M17.715 8.671h.015', key: 'svg-3' }],
  ['path', { d: 'M15.415 5.971h.015', key: 'svg-4' }],
]);
